import { createReducer, on } from '@ngrx/store';
import * as UtilityActions from './utility.actions';
import { IUtilitReducer } from './../models/utility-reducer.interface';

// Initial state
const initState: IUtilitReducer = {
  isDiamondAirline: false,
  isHubdropBooking: false,
  selectPostOffice: null,
  bagItems: {
    bags: 1,
    childEquipment: 0,
    oversizeItem: 0
  },
  amendZoneId: ''
};

// Reducer using createReducer and on
export const utilityReducer = createReducer(
  initState,
  on(UtilityActions.isDiamondAirline, (state, { payload }) => ({
    ...state,
    isDiamondAirline: payload
  })),
  on(UtilityActions.isBookingHubdropBooking, (state, { payload }) => ({
    ...state,
    isHubdropBooking: payload
  })),
  on(UtilityActions.updateAmendZoneId, (state, { payload }) => ({
    ...state,
    amendZoneId: payload
  })),
  on(UtilityActions.setSelectedPostOffice, (state, { payload }) => ({
    ...state,
    selectPostOffice: payload
  })),
  on(UtilityActions.setCurrentBagItems, (state, { payload }) => ({
    ...state,
    bagItems: payload
  })),
  on(UtilityActions.refreshUtilityReducer, (state, { payload }) => ({
    ...payload
  })),
  on(UtilityActions.resetUtilityReducer, () => ({
    ...initState
  }))
);
